import React, { useMemo } from "react";

const sanitize = (value) => (typeof value === "string" ? value.trim() : "");

const InterestSection = ({ fields }) => {
    const sanitizedData = useMemo(() => {
        if (!fields) return null;

        const eyebrow = sanitize(fields.eyebrow || "");
        const title = sanitize(fields.title || "");

        const grid1 = Array.isArray(fields.grid_1)
            ? fields.grid_1
                .map((item) => {
                    const imageUrl = item?.image?.url || "";
                    const imageAlt = item?.image?.alt || "";
                    const caption = sanitize(item?.caption || "");
                    if (!imageUrl) return null;
                    return { imageUrl, imageAlt, caption };
                })
                .filter(Boolean)
            : [];

        const grid2 = Array.isArray(fields.grid_2)
            ? fields.grid_2
                .map((item) => {
                    const imageUrl = item?.image?.url || "";
                    const imageAlt = item?.image?.alt || "";
                    const caption = sanitize(item?.caption || "");
                    if (!imageUrl) return null;
                    return { imageUrl, imageAlt, caption };
                })
                .filter(Boolean)
            : [];

        const hasContent = eyebrow || title || grid1.length > 0 || grid2.length > 0;
        if (!hasContent) return null;

        return { eyebrow, title, grid1, grid2 };
    }, [fields]);

    if (!sanitizedData) return null;

    const { eyebrow, title, grid1, grid2 } = sanitizedData;

    return (
        <section className="interest-section">
            <div className="canvas">
                <div className="interest-section-inner">
                    {(eyebrow || title) && (
                        <div className="interest-title-sec" data-stagger-index="0">
                            {eyebrow && <p className="interest_eyebrow">{eyebrow}</p>}
                            {title && <h2 className="interest-title">{title}</h2>}
                        </div>
                    )}

                    {/* {(grid1.length > 0 || grid2.length > 0) && (
                        <div className="interest-grid">
                            {grid1.length > 0 && (
                                <div className="interest-grid-1">
                                    {grid1.map((item, index) => {
                                        const cardClasses = ["interest-card"];
                                        if (index === 0) cardClasses.push("first");
                                        if (index === 1) cardClasses.push("second");
                                        if (index === 2) cardClasses.push("third");

                                        return (
                                            <div
                                                className={cardClasses.join(" ")}
                                                key={`grid1-${index}`}
                                                data-flag={index === 0 ? "🇩🇪" : undefined}
                                                data-stagger-index={index + 1}
                                            >
                                                <img
                                                    src={item.imageUrl}
                                                    alt={item.imageAlt || item.caption || `Grid 1 Image ${index + 1}`}
                                                />
                                                {item.caption && (
                                                    <div className="caption">{item.caption}</div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {grid2.length > 0 && (
                                <div className="interest-grid-2">
                                    {grid2.map((item, index) => (
                                        <div
                                            className="interest-card"
                                            key={`grid2-${index}`}
                                            data-stagger-index={grid1.length + index + 1}
                                        >
                                            <img
                                                src={item.imageUrl}
                                                alt={item.imageAlt || item.caption || `Grid 2 Image ${index + 1}`}
                                            />
                                            {item.caption && (
                                                <div className="caption">{item.caption}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )} */}

                    {(grid1.length > 0 || grid2.length > 0) && (
                        <div className="interest-grid">
                            {grid1.length > 0 && (
                                // 👇 Group gets stagger index, cards inside animate together
                                <div
                                    className="interest-grid-1"
                                    data-stagger-index="1"
                                >
                                    {grid1.map((item, index) => {
                                        const cardClasses = ["interest-card"];
                                        if (index === 0) cardClasses.push("first");
                                        if (index === 1) cardClasses.push("second");
                                        if (index === 2) cardClasses.push("third");

                                        return (
                                            <div
                                                className={cardClasses.join(" ")}
                                                key={`grid1-${index}`}
                                                data-flag={index === 0 ? "🇩🇪" : undefined}
                                            >
                                                <img
                                                    src={item.imageUrl}
                                                    alt={item.imageAlt || item.caption || `Grid 1 Image ${index + 1}`}
                                                />
                                                <div  id="about-blur-layer"></div>
                                                {item.caption && (
                                                    <div className="caption">{item.caption}</div>
                                                )}
                                            </div>
                                        );
                                    })}
                                </div>
                            )}

                            {grid2.length > 0 && (
                                // 👇 grid-2 can be next in the stagger chain if you want
                                <div
                                    className="interest-grid-2"
                                    data-stagger-index={grid1.length > 0 ? 2 : 1}
                                >
                                    {grid2.map((item, index) => (
                                        <div
                                            className="interest-card"
                                            key={`grid2-${index}`}
                                        >
                                            <img
                                                src={item.imageUrl}
                                                alt={item.imageAlt || item.caption || `Grid 2 Image ${index + 1}`}
                                            />
                                            <div  id="about-blur-layer"></div>

                                            {item.caption && (
                                                <div className="caption">{item.caption}</div>
                                            )}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div>
                    )}

                </div>
            </div>
        </section>
    );
};

export default InterestSection;
